<template>
  <div class="container-fluid mt-3" style="max-width: 800px">
    <div class="row mb-3 g-3 mt-3">
      <div class="col">
        <h5><strong>Indique um Amigo</strong></h5>
        <div class="a-divider a-divider-break"></div>
      </div>
    </div>
    <div class="row m-3" v-if="erro">
      <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
        {{ erro }}
      </div>
    </div>



    <div class="col-12 row pad-0" style="text-align: center">
      <b style="margin: auto">
        <h4 class="texto-titulo">{{ cupomIndicacao.titulo }}</h4>
      </b>
    </div>

    <div class="col-12 row pad-0" style="text-align: center">
      <span style="
          margin: auto;
          font-size: 15px;
          padding-left: 33px;
          padding-right: 33px;
        ">
        {{ cupomIndicacao.descricao }}
      </span>
    </div>

    <div class="col-12 row pad-0 padding-button mt-2" style="text-align: center">
      <b style="margin: auto">
        <span style="text-align: center" class="font-texto-indicacao">Compartilhe seu código</span>
      </b>
    </div>

    <div class="col-12 row pad-0 padding-button mt-3" style="text-align: center">
      <b class="codigo-cupom">
        <span class="texto-codigo-cupom">{{ cupomIndicacao.codigoCupom }}</span>
      </b>
    </div>

    <div class="row align-items-center text-center mt-3">
      <div class="col-6 pad-0 padding-button" @click="whatsApp">
        <div class="col-12">
          <img style="width: 22px" src="@/assets/images/whatsapp-brands.svg" />
        </div>
        <div class="col-12">WhatsApp</div>
      </div>
      <div class="col-6 row pad-0 padding-button" @click="copiarCodigo">
        <div class="col-12">
          <img style="width: 22px" src="@/assets/images/clone-solid.svg" />
        </div>
        <div class="col-12">Copiar Código</div>
      </div>
    </div>

    <div class="row mt-3 align-items-center text-center">
      <span class="col-12">
        <a href="#" data-bs-toggle="modal" data-bs-target="#exampleModal">
          <div class="flex-shrink-1">
            <span class="cor-principal ml-2"><strong>Leia o regulamento</strong></span>
          </div>
        </a>

      </span>
    </div>
    <div class="px-5 pt-1 pb-5">
      <div class="row mb-3 g-3 mt-5">
        <div class="col">
          <h5><strong>Indicações</strong></h5>
          <div class="a-divider a-divider-break"></div>
        </div>
      </div>



      <ul class="list-group list-group-flush">

        <li class="card px-4 py-3 mb-4 shadow btn text-left" v-for="(indicacao, i) in indicacoes" :key="i">
          <div class="d-flex justify-content-between flex-column flex-lg-row">
            <span><small><strong>Nome:</strong></small><br />{{ indicacao.usuarioIndicado.nome }}
            </span>
            <span><small><strong>Situação:</strong></small><br />{{ indicacao.situacaoIndicacao ?? "Não Informado" }}
            </span>
            <span>
              <small><strong>Data Cadastro:</strong></small> <br />
              <span class="badge-light"> {{ formatDate(indicacao.dataCadastro) }}</span>
            </span>
            <span><small> <strong>Data do Crédito</strong></small><br />
              {{ formatDate(indicacao.dataCredito) }}
            </span>
            <span><small><strong>Valor do Crédito</strong><br /> </small>R$
              {{ formatPrice(indicacao.valorCredito) }}</span>

          </div>
        </li>
      </ul>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-full">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Regulamento</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
          </div>
          <div class="modal-body">
            <div class="modal-body-full" v-html="cupomIndicacao.regulamento"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">Fechar</button>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import { APIService } from "../APIService";
const apiService = new APIService();

export default {
  name: "Indicacao",
  components: { Loading },
  data() {
    return {
      cupomIndicacao: "",
      sucessoRequisicao: false,
      erroRequisicao: false,
      toggleRegulamento: false,
      loading: false,
      indicacoes: [],
      erro: "",
      toogleMicroApp: false,
      urlBase: window.API_BASE_URL.replace('/api', '')
    };
  },
  mounted() { },
  created() {
    this.getcodigoCupom();
    this.getIndicacoesPendentes();
    this.toogleMicroApp = this.$store.state.toogleMicroApp;
  },
  methods: {
    copiarCodigo() {
      var selBox = document.createElement("textarea");
      selBox.style.position = "fixed";
      selBox.style.left = "0";
      selBox.style.top = "0";
      selBox.style.opacity = "0";
      selBox.value = this.cupomIndicacao.codigoCupom;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand("copy");
      document.body.removeChild(selBox);
      alert(
        "Código " + this.cupomIndicacao.codigoCupom + " copiado com sucesso!"
      );
    },
    whatsApp() {

      if (this.toogleMicroApp) {
        window.location.href =
          "https://api.whatsapp.com/send?text=" +
          this.urlBase +
          "/app/" +
          this.cupomIndicacao.codigoRede +
          "/indicacao/" +
          this.cupomIndicacao.codigoCupom;
      } else {
        window.location.href =
          "whatsapp://send?text=" +
          this.urlBase +
          "/app/" +
          this.cupomIndicacao.codigoRede +
          "/indicacao/" +
          this.cupomIndicacao.codigoCupom;
      }
    },

    openRegulamento() {
      this.$swal({
        title: "Regulamento",
        html: `<div style="overflow: auto;max-height: 80vh;">${this.cupomIndicacao.regulamento}</div>`,
        confirmButtonText: "Ok",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          console.log(res);
        }
      });
    },
    getcodigoCupom() {
      this.loading = true;
      apiService
        .getcodigoCupom()
        .then((response) => {
          this.cupomIndicacao = response;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatDate(date) {
      if (!date) {
        return "Não informado";
      }
      return this.$moment(date).format("DD/MM/YYYY");
    },
    getIndicacoesPendentes() {
      this.loading = true;
      apiService
        .getIndicacoesPendentes()
        .then((response) => {
          this.indicacoes = response;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>


<style scoped lang="scss">
.codigo-cupom {
  margin: auto;
  border-style: dashed;
  width: 70%;
  padding: 10px;
  border-color: rgba(204, 204, 204, 0.5);
}

.margin-auto {
  margin: auto;
}

.texto-comp {
  padding-top: 8px;
  padding-bottom: 25px;
  font-size: 14px;
}

.texto-compartilhe {
  margin: auto;
  font-size: 14px;
  padding-left: 33px;
  padding-right: 33px;
  padding-top: 5px;
}

.texto-titulo {
  font-family: "Hind", sans-serif;
  font-weight: bold;
  font-size: 19px;
}

.texto-codigo-cupom {
  text-align: center;
  color: blue;
}

.circulo {
  color: var(--cor-texto) !important;
  background: var(--cor-principal) !important;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border-radius: 50%;
  font-size: 25px;
  top: 70px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;

  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: center;
}

.font-texto-indicacao {
  font-size: 14px;
}

.whatsapp {
  color: #34af23;
}

.glyphicon-lg {
  font-size: 4em;
}

.info-block {
  border-right: 5px solid #e6e6e6;
  margin-bottom: 25px;
}

.info-block .square-box {
  width: 100px;
  min-height: 110px;
  margin-right: 22px;
  text-align: center !important;
  background-color: #676767;
  padding: 20px 0;
}

.info-block.block-info {
  border-color: #20819e;
}

.info-block.block-info .square-box {
  background-color: #20819e;
  color: #fff;
}
</style>